






























import { Component, Vue } from 'vue-property-decorator';
import { WebService } from '@/@types/LibraryComponent';

@Component
export default class Integrations extends Vue {
  private integrations: Array<WebService> = [
    {
      serviceName: 'Webhook',
      explanation:
        '課題の追加などで発生したイベント情報をリアルタイムに指定されたURLへHTTP POSTできます',
      image: require('@/assets/webhook.png'),
    },
    {
      serviceName: 'Typetalk',
      explanation:
        'コメントの追加など、Theoryに新しい動きがあったときにSlackでお知らせを受け取れます。',
      image: require('@/assets/typetalk.png'),
    },
    {
      serviceName: 'Cacoo',
      explanation:
        'Theoryのコメントや課題、Wikiに、Cacooの図を挿入してコミュニケーションを四角的に整理できます。',
      image: require('@/assets/Cacoo.png'),
    },
    {
      serviceName: '課題一括登録',
      explanation:
        'Googleスプレッドシートを使って、Theoryへ課題を一括登録できます。',
      image: require('@/assets/Google.webp'),
    },
    {
      serviceName: 'iCal',
      explanation:
        'Google、Apple、Outlookのカレンダーとプロジェクトのマイルストーンを同期して期限日を把握できます',
      image: require('@/assets/iCal.webp'),
    },
  ];
}
